// "Showing 51–100 of 734" + Previous / Next. Lists used to stop silently at a fixed cap; this makes the
// true total visible and every row reachable.
export default function Pager({ page, pageSize, total, onPage }) {
  if (!total) return null;
  const first = (page - 1) * pageSize + 1;
  const last = Math.min(page * pageSize, total);
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const btn = 'rounded-md border border-line px-3 py-1.5 text-sm text-text-secondary hover:bg-surface-raised disabled:opacity-40';
  return (
    <div className="mt-3 flex flex-wrap items-center justify-between gap-2 text-sm text-text-muted">
      <span>
        Showing {first.toLocaleString()}–{last.toLocaleString()} of {total.toLocaleString()}
      </span>
      {pages > 1 && (
        <div className="flex items-center gap-2">
          <button type="button" className={btn} disabled={page <= 1} onClick={() => onPage(page - 1)}>
            Previous
          </button>
          <span className="tabular-nums">
            Page {page} of {pages}
          </span>
          <button type="button" className={btn} disabled={page >= pages} onClick={() => onPage(page + 1)}>
            Next
          </button>
        </div>
      )}
    </div>
  );
}
